import axios from "axios";

const baseUrlDev = "https://api-dev-btoc-vitals.carenow.healthcare/v2";

export const apiAxios = axios.create({
  baseURL: baseUrlDev,
});

const baseUrlDev2 = "https://api-staging-sdk-wrapper-app.carenow.healthcare/v2";

export const apiAxios2 = axios.create({
    baseURL: baseUrlDev2,
  });

  

  const baseUrlDev3 = "https://sdk-staging.carenow.healthcare/";

  export const apiAxios3 = axios.create({
      baseURL: baseUrlDev3,
  });


export const API_KEY = "CNCP7WP9kBDssPVtu61e";  //Birla Dev

export const SECRET_KEY = "aOfzaucVmyf37wXJ9ASsAqVlUkaEXpqqMjWqUQlF";